import { useState, useRef, useEffect } from "react";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import "./Subscription.scss";

const OverflowTooltip = ({ text }) => {
    const textRef = useRef(null);
    const [isOverflowing, setIsOverflowing] = useState(false);

    useEffect(() => {
        const checkOverflow = () => {
            if (textRef.current) {
                setIsOverflowing(textRef.current.scrollWidth > textRef.current.clientWidth);
            }
        };

        checkOverflow();
        window.addEventListener("resize", checkOverflow);
        return () => window.removeEventListener("resize", checkOverflow);
    }, []);

    return (
        <Tooltip title={isOverflowing ? text : ""} disableHoverListener={!isOverflowing}>
            <Typography ref={textRef} className="cardtile-typography">
                {text}
            </Typography>
        </Tooltip>
    );
};

export default OverflowTooltip;
